module.exports = __webpack_public_path__ + "img/signable_cta_screenshot_full.559851b1.webp";